
import {
  defineComponent,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  ref,
  onBeforeUnmount,
} from "vue";
import QrcodeVue from "qrcode.vue";
import { useRouter } from "vue-router";
import {
  getUserInfo,
  newNumber,
  parseImgUrl,
  setLocalProjectId,
  setQueryConfig,
} from "@/utils";
import { UserActionTypes } from "@/store/modules/user/action-types";
import { store, useStore } from "@/store";
import { login } from "@/apis/user";
import { Form, Field, CellGroup, Button, Toast } from "vant";
import { getCookieMac, setToken } from "@/utils/cookies";
import { getPadQrCodeStatus, queryWorkSpace } from "@/apis/envmonitor";
import { getUrlParams } from "@/utils/https";
import { UserMutationTypes } from "@/store/modules/user/mutation-types";
import router from "@/router";

export default defineComponent({
  components: {
    QrcodeVue,
    vanForm: Form,
    vanField: Field,
    CellGroup,
    vanButton: Button,
  },
  beforeRouteEnter(to, from, next) {
    // 不能获取组件实例
    // 因为当守卫执行前，组件实例还没被创建
    console.log("路由导航首位---");
    console.log(to);
    console.log(from);
    // next()
    if (to.query.type !== "logoOut") {
      next((e: any) => {
        console.log(e);
        e.queryWorkSpace();
      });
    } else {
      next((e: any) => {
        e.showLogin = true;
        let mac: any = getCookieMac();
        console.log(mac);
        // to.query = { mac: mac};
        console.log(to);
        // console.log( e.showLogin )
        // router.push({ name: "home", query: { mac: mac } });
      });
    }
  },
  setup(props) {
    let router: any = useRouter();
    const userInfo: any = getUserInfo();
    const store = useStore();
    const codeStatus: any = {};
    const timer: any = null;
    const orgin: any = location.origin;
    const proxyData = reactive({
      parseImgUrl: parseImgUrl,
      codeValue: `${orgin}/sgipad/home`,
      showLogin: false,
      size: 134,
      type: 1, // 1:二维码登录 2:用户密码登录
      userInfo: userInfo,
      checkLoginType() {
        if (proxyData.type === 1) {
          proxyData.type = 2;
        } else {
          proxyData.type = 1;
        }
        if (proxyData.type === 1) {
          proxyData.getPadQrCodeStatus();
        } else {
          if (proxyData.timer) {
            clearTimeout(proxyData.timer);
            proxyData.timer = null;
          }
        }
      },
      username: "",
      password: "",
      onSubmit(values: any) {
        console.log("submit", values);
        let params: any = values;
        login(params).then((res) => {
          let resData: any = res;
          if (resData.result === "success") {
            setToken(resData.token);
            router.push({ path: "/choice-project" });
          } else {
            Toast("登录失败!");
          }
        });
      },
      // 查询工作空间
      queryWorkSpace() {
        if (!proxyData.userInfo.mac) {
          proxyData.showLogin = true;
        } else {
          let params: any = {
            criteria: {
              macAddress: proxyData.userInfo.mac,
              isMajorSpace: 1,
            },
            orders: [
              {
                column: "createTime",

                asc: false,
              },
            ],
            page: 1,
            size: 1,
          };
          queryWorkSpace(params)
            .then((res: any) => {
              let resData: any = res;
              if (resData.result === "success") {
                let content: any = resData?.content ?? [];
                if (content && content.length) {
                  proxyData.showLogin = false;
                  let projectId: any = content[0].projectId;
                  store.commit(UserMutationTypes.SET_PROJECT_ID, projectId);
                  router.push({
                    name: "envmonitor",
                    query: { spaceId: content[0].spaceId },
                  });
                } else {
                  proxyData.showLogin = true;
                }
              } else {
                proxyData.showLogin = true;
              }
            })
            .catch(() => {
              proxyData.showLogin = true;
            });
        }
      },
      /**
       * 获取mac地址
       */
      getQrcode() {
        let mac: any = proxyData.userInfo.mac;
        const id: any = newNumber(0, 100000, mac);
        return id;
      },
      qrCodeId: "",
      setCodeUrl() {
        let mac: any = proxyData.userInfo.mac;
        let qrCodeId: any = proxyData.getQrcode();
        proxyData.qrCodeId = qrCodeId;
        proxyData.codeValue = `${orgin}/sgipad/home?type=ipad&id=${proxyData.qrCodeId}&mac=${mac}`;
      },
      //  定时器清楚
      clearTimer() {
        if (proxyData.timer) {
          clearTimeout(proxyData.timer);
          proxyData.timer = null;
        }
      },
      // 二维码刷新
      refreshCode() {
        proxyData.setCodeUrl();
        proxyData.clearTimer();
        proxyData.getPadQrCodeStatus();
      },
      /**
       *
       *获取二维码状态
       */
      codeStatus: codeStatus,
      timer: timer,
      getPadQrCodeStatus() {
        let params: any = setQueryConfig({ qrCodeId: proxyData.qrCodeId });
        getPadQrCodeStatus(params).then((res) => {
          let resData: any = res;
          proxyData.codeStatus = resData?.data ?? {};
          if (proxyData.codeStatus.status === 2) {
            // debugger
            let projectId: any = proxyData.codeStatus.projectId;
            let spaceId: any = proxyData.codeStatus.spaceId;
            if (projectId && spaceId) {
              // 直接去环境条件页面
              // setLocalProjectId(projectId)
              store.commit(UserMutationTypes.SET_PROJECT_ID, projectId);
              router.push({
                name: "choiceSpace",
                query: { id: projectId, spaceId: spaceId },
              });
            } else if (projectId) {
              // 去选择项目页面
              store.commit(UserMutationTypes.SET_PROJECT_ID, projectId);
              router.push({ name: "choiceSpace", query: { id: projectId } });
            }
          } else {
            if (proxyData.timer) {
              clearTimeout(proxyData.timer);
              proxyData.timer = null;
            }
            proxyData.timer = setTimeout(() => {
              proxyData.getPadQrCodeStatus();
            }, 1000);
          }
        });
      },
    });
    onBeforeUnmount(() => {
      if (proxyData.timer) {
        clearTimeout(proxyData.timer);
        proxyData.timer = null;
      }
    });
    onMounted(() => {
      // 设置二维码路径
      proxyData.setCodeUrl();
      proxyData.getPadQrCodeStatus();
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
